import React from "react";
import Layout from "./Layout";
import { BlogPostContent } from "./BlogPostContent";

const BlogPostExport = (props) => (
  <Layout disableBreadCrumb {...props}>
    <BlogPostContent {...props} />
  </Layout>
);

export default BlogPostExport;
